/* eslint-disable react/no-multi-comp */
'use strict';

import React, { Component } from 'react'

import { v4 as uniqid } from 'uuid'
import _      from 'lodash'

import Layout from '@Layout/ECFront'

import SliderWithSideElement from '@/Wrapper/SliderWithSideElement'
import FrontVideoSlider      from '@/Wrapper/FrontVideoSlider'
import HolidaysMessage       from '@/HolidaysMessage'
import PrivateSaleLink       from '@/PrivateSaleLink'
import Slider                from '@/Slider'

import PiggyBankIcon from '@/Icons/PiggyBank'
import InstagramIcon from '@/Icons/Instagram'
import BuildingIcon  from '@/Icons/Building'
import FacebookIcon  from '@/Icons/Facebook'
import HolidaysIcon  from '@/Icons/Holidays'
import TicketIcon    from '@/Icons/Ticket'
import InfoIcon      from '@/Icons/Info'

import GetActivePrivateSales from '@fetcher/GetActivePrivateSales'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Logo   from '@Pure/Logo'

import bemit from '@function/bemit'

import { getOnlineType, isTrue } from '@root/utility'

const types_i18n =
{
	show_product: 'Spectacle',
	parc_product: 'Parc d\'attraction',
	default: 'Billet'
};

const app = window.app;

const qwest = window.qwest;

export default class ECFrontDashboardPage extends Component
{
	state =
	{
		partners: [],
		admin_articles: [],
		blog_articles: [],
		ad_articles: [],
		legal_articles: [],

		width: window.innerWidth,
		render_id: uniqid(),

		welcome_txt: app.state.session?.EC?.presentation_text,

		loading: true
	};

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();

		component.handleSessionChange();

		component.setState({ loading: true });

		qwest.post('/dashboard-front')
		.then(function (xhr, response)
		{
			let places = response.places || [];

			const products = response.products.map(function (product)
			{
				product._artist = response.artists
				.find(artist => artist.id === product.artist);

				product._places = (product.places || []).map(function (place_id)
				{
					return places.find(place => place.id === place_id);
				})
				.filter(place => Boolean(place));

				product._type = types_i18n[product.type] || types_i18n.default;

				return product;
			});

			let front_highlight = [], products_and_places = products.concat(places);

			const highlighted_count = places.length + products.length;

			for (let i = 0; i < highlighted_count; i++)
			{
				const data =
				{
					id: uniqid(),

					type: products[i] ? 'product' : 'place',

					model: products[i] || products_and_places[i]
				};

				if (data.model) front_highlight.push(data);
			}

			component.setState(
			{
				front_highlight: front_highlight,

				partners: response.partners || [],

				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.push(
		{
			event: 'window.resize',
			cb: component.handleResize
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.delete(
		{
			event: 'window.resize',
			cb: component.handleResize
		});
	}

	handleResize = ({ source }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (window.innerWidth !== state.width)
		{
			component.setState({ width: window.innerWidth, render_id: uniqid() });
		}
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		const permissions = app.state.session?.permissions || { };

		if (!permissions.title || permissions.title === 'not_auth') return;

		component.setState(
		{
			permissions: permissions,

			welcome_txt: app.state.session?.EC?.welcome
		});

		if (permissions.title === 'EC' && state.admin_articles.length === 0)
		{
			component.fetchAdminBlog();
			component.fetchLegalBlog();
		}
		else if (permissions.title !== 'EC' && state.blog_articles.length === 0)
		{
			component.fetchBlog();
		}

		component.fetchPromoBlog();
	}

	fetchBlog ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ blog_loading: true });

		let filter_query =
		{
			type: 'EC',

			EC: app.state.session.EC?.id,

			sort: 'date DESC',

			limit: state.width > 1400 ? 5
			: state.width >= 1024 ? 4
			: state.width >= 768 ? 3
			: 1
		};

		qwest.post('/CMS/getAll',
		{
			model: 'blog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				blog_loading: false,
				blog_articles: response.data
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	fetchLegalBlog ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ legal_loading: true });

		let filter_query =
		{
			type: 'legal',

			sort: 'date DESC',

			limit: state.width > 1400 ? 5 * 3
			: state.width >= 1024 ? 4 * 3
			: state.width >= 768 ? 3 * 4
			: 1 * 8
		};

		qwest.post('/CMS/getAll',
		{
			model: 'blog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				legal_loading: false,
				legal_articles: response.data
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	fetchPromoBlog ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ promo_loading: true });

		let filter_query =
		{
			sort: 'date DESC',

			limit: state.width > 1400 ? 5 * 3
			: state.width >= 1024 ? 4 * 3
			: state.width >= 768 ? 3 * 4
			: 1 * 8
		};

		qwest.post('/CMS/getAll',
		{
			model: 'adblog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				promo_loading: false,
				ad_articles: (response.data || [])
				.filter(blog => [true, 'true'].includes(blog.disabled) === false)
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	fetchAdminBlog ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		let filter_query =
		{
			type: 'synergies',
			limit: 20,
			sort: 'date DESC',

			disabled: { '!=': [true, 'true'] }
		};

		qwest.post('/CMS/getAll',
		{
			model: 'blog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				admin_articles: response.data || []
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handlePrivateSale = (private_sales) =>
	{
		const component = this, props = this.props, state = this.state;

		if (private_sales && private_sales.length > 0)
		{
			component.setState({ active_private_sales: private_sales });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const permissions = state.permissions || { };

		const can_access_partners = isTrue(permissions.access_partners);

		const can_access_EC_space = !app.state.session.EC
		? false
		: !isTrue(app.state.session.EC?.admin_users_only);

		const is__admin = permissions?.title === 'Membre de synergies';

		const is__member = ['Membre de CE', 'Administrateur de CE']
		.includes(permissions?.title);

		let output, loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['yellow', 'bg-white'] } />;
		}

		const partners_space_block = can_access_partners || is__admin ?
		(
			<div className="o-grid__item-3 u-flex home-partners-space">

				<div className="c-color-block c-color-block--img
					c-color-block--partners c-color-block--thiner">

					{ loader }

					<PiggyBankIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Encore { '+' } d'avantages
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/espace-partenaires"
					/>

				</div>

			</div>
		)
		: undefined;

		const artists_block =
		(
			<div className={ 'o-grid__item-' + (partners_space_block ? '3' : '4') +
				' u-flex' }>

				<div className="c-color-block c-color-block--img c-color-block--artists c-color-block--thiner">
					{ loader }

					<svg className="o-svg-icon o-svg-icon--artist c-color-block__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-artist"></use>
					</svg>

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Les artistes &amp; festivals
						</div>
					</div>

					<Link className="c-color-block__link" href="/accueil/artistes"></Link>

				</div>

			</div>
		);

		const my_EC_block =
		(
			<div className="o-grid__item-3 home-logo">

				<div className="c-color-block c-color-block--img c-color-block--CE">

					{ loader }

					<Logo className="c-color-block__logo" type="svg"
						dynamic={ true }
					/>

				</div>

			</div>
		);

		const meeting_records_block = can_access_EC_space ?
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img
					c-color-block--meeting-record">

					{ loader }

					<svg className="o-svg-icon o-svg-icon--meeting_record c-color-block__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-meeting_record"></use>
					</svg>

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Comptes rendus de réunion
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/mon-espace/comptes-rendus-de-reunion"
					/>

				</div>

			</div>
		)
		: undefined;

		const products_block =
		(
			<div className={ 'o-grid__item-' + (partners_space_block ? '3' : '4') +
				' u-flex' }>

				<div className="c-color-block c-color-block--img c-color-block--places c-color-block--thiner">
					{ loader }

					<TicketIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Billetteries
						</div>
					</div>

					<Link className="c-color-block__link" href="/accueil/catalogue"></Link>

				</div>

			</div>
		);

		const holidays_block =
		(
			<div className={ 'o-grid__item-' + (partners_space_block ? '3' : '4') +
				' u-flex' }>

				<div className="c-color-block c-color-block--img c-color-block--sejours c-color-block--thiner">
					{ loader }

					<HolidaysIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Séjours &amp; vacances
						</div>
					</div>

					<Link className="c-color-block__link" href="/accueil/sejours-vacances"></Link>

				</div>

			</div>
		);

		let slides = [], i = 0;

		const per_slide = state.width >= 1326 ? 5
		: state.width >= 1024 ? 4
		: state.width >= 768 ? 3
		: 1;

		(state.front_highlight || []).forEach(function (data)
		{
			let active = slides[i];

			if (!active || active.content.length >= per_slide)
			{
				if (active && active.content.length >= per_slide)
				{
					i++;
				}

				slides.push(
				{
					id: data.id,

					content: []
				});
			}

			const content = data.type === 'product'
			? <Product product={ data.model } key={ data.model.id } />
			: <Place place={ data.model } key={ data.model.id } />;

			slides[i].content.push(content);
		});

		let front_highlight = slides.map(function (slide)
		{
			let i = 0;

			while (slide.content.length < per_slide)
			{
				const placeholder =
				(
					<div className={ bemit('c-model-preview-item',
						['product', 'slider']) }
						key={ i++ }
					/>
				);

				slide.content.push(placeholder);
			}

			const data =
			{
				id: slide.id,

				content:
				(
					<div className="u-flex u-full-width">
						{ slide.content }
					</div>
				)
			};

			return data;
		});

		let blog_articles = permissions?.title === 'EC'
		? state.admin_articles
		: state.blog_articles;

		let article_slides = [];

		i = 0;

		blog_articles.forEach(function (blog)
		{
			let active = article_slides[i];

			if (!active || active.content.length >= per_slide)
			{
				if (active && active.content.length >= per_slide)
				{
					i++;
				}

				article_slides.push(
				{
					id: blog.id,

					content: []
				});
			}

			const content =
			(
				<BlogArticle blog={ blog } key={ blog.id }
					type={ permissions?.title === 'EC' ? 'synergies' : 'EC' }
				/>
			);

			article_slides[i].content.push(content);
		});

		const video_slider_slides = window.innerWidth >= 1480 ? 4
		: window.innerWidth >= 1326 ? 3
		: window.innerWidth >= 1024 ? 2
		: 1;

		let blog_items = article_slides.map(function (slide)
		{
			let i = 0;

			while (slide.content.length < per_slide)
			{
				const placeholder =
				(
					<div className={ bemit('c-model-preview-item',
						['blog', 'slider']) }
						key={ i++ }
					/>
				);

				slide.content.push(placeholder);
			}

			const data =
			{
				id: slide.id,

				content:
				(
					<div className="u-flex u-full-width">
						{ slide.content }
					</div>
				)
			};

			return data;
		});

		let ad_slides = [];

		i = 0;

		state.ad_articles.forEach(function (blog)
		{
			let active = ad_slides[i];

			if (!active || active.content.length >= video_slider_slides)
			{
				if (active && active.content.length >= video_slider_slides)
				{
					i++;
				}

				ad_slides.push(
				{
					id: blog.id,

					content: []
				});
			}

			const content =
			(
				<BlogArticle blog={ blog } key={ blog.id }
					type="ad" bemit={ ['side-of-video'] }
				/>
			);

			ad_slides[i].content.push(content);
		});

		let ad_items = (is__member || is__admin ? ad_slides : []).map(function (slide)
		{
			let i = 0;

			while (slide.content.length < video_slider_slides)
			{
				const placeholder =
				(
					<div className={ bemit('c-model-preview-item',
						['blog', 'slider', 'ad']) }
						key={ i++ }
					/>
				);

				slide.content.push(placeholder);
			}

			const data =
			{
				id: slide.id,

				content:
				(
					<div className="u-flex u-full-width">
						{ slide.content }
					</div>
				)
			};

			return data;
		});

		let legal_articles = permissions?.title === 'EC'
		? state.legal_articles
		: [];

		let legal_slides = [];

		i = 0;

		legal_articles.forEach(function (blog)
		{
			let active = legal_slides[i];

			if (!active || active.content.length >= per_slide)
			{
				if (active && active.content.length >= per_slide)
				{
					i++;
				}

				legal_slides.push(
				{
					id: blog.id,

					content: []
				});
			}

			const content =
			(
				<BlogArticle blog={ blog } key={ blog.id }
					type="legal"
				/>
			);

			legal_slides[i].content.push(content);
		});

		let legal_items = legal_slides.map(function (slide)
		{
			let i = 0;

			while (slide.content.length < per_slide)
			{
				const placeholder =
				(
					<div className={ bemit('c-model-preview-item',
						['blog', 'slider', 'legal']) }
						key={ i++ }
					/>
				);

				slide.content.push(placeholder);
			}

			const data =
			{
				id: slide.id,

				content:
				(
					<div className="u-flex u-full-width">
						{ slide.content }
					</div>
				)
			};

			return data;
		});

		let presentation_text;

		if (state.welcome_txt)
		{
			presentation_text = state.welcome_txt
			.split('<p><br></p>')
			.join('');

			presentation_text =
			(
				<div className="EC-presentation-text"
					dangerouslySetInnerHTML={ { __html: presentation_text } }>
				</div>
			);
		}

		const infos_block = can_access_EC_space ?
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img
					c-color-block--EC-infos">

					{ loader }

					<BuildingIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Infos pratiques
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/mon-espace/infos-pratiques"
					/>

				</div>

			</div>
		)
		: undefined;

		const blog_block = can_access_EC_space ?
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img c-color-block--news">

					{ loader }

					<InfoIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Infos &amp; Actus
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/mon-espace/blog"
					/>

				</div>

			</div>
		)
		: undefined;

		const member_ad_blog_slider = is__member || is__admin ?
		(
			<FrontVideoSlider>
				<div className="dashboard-list u-margin-top-0">

					<div className="c-title c-title--v2 u-margin-top-20">
						<h2 className="c-title__txt">
							En ce moment
						</h2>
					</div>

					{
						ad_items.length > 0 ?
						(
							<Slider key={ state.render_id }
								type="custom"
								elements={ ad_items }
								bemit={ ['highlighted-blog', 'ad-blog',
									'multiple', 'side-of-video'] }
								hide-progress
							/>
						)
						: undefined
					}

				</div>
			</FrontVideoSlider>
		)
		: undefined;

		const catalog_links =
		(
			<>
				{ partners_space_block }

				{ holidays_block }

				{ products_block }

				{ artists_block }
			</>
		);

		const right_elements = can_access_EC_space ?
		(
			<div className="o-grid-3 u-flex">

				{ infos_block }

				{ blog_block }

				{ meeting_records_block }

			</div>
		)
		:
		(
			<div className="o-grid-4 u-flex">

				{ catalog_links }

			</div>
		);

		const highlighted_section = permissions?.title === 'EC' &&
			!isTrue(app.state.session?.EC?.admin_users_only) ?
		(
			<div className="dashboard-list">

				<div className="c-title c-title--v2 u-margin-top-20">
					<h2 className="c-title__txt">
						Infos juridiques
					</h2>
				</div>

				{
					legal_items.length > 0 ?
					(
						<Slider key={ state.render_id }
							type="custom"
							elements={ legal_items }
							bemit={ ['highlighted', 'multiple'] }
							hide-progress auto
						/>
					)
					: undefined
				}

			</div>
		)
		: permissions?.title !== 'EC' ?
		(
			<div className="dashboard-list">

				<div className="c-title c-title--v2 u-margin-top-20">
					<h2 className="c-title__txt">
						À ne pas rater
					</h2>
				</div>

				{
					front_highlight.length > 0 ?
					(
						<Slider key={ state.render_id } type="custom"
							elements={ front_highlight }
							bemit={ ['highlighted', 'multiple'] }
							hide-progress auto
						/>
					)
					: undefined
				}

			</div>
		)
		: undefined;

		const synergies_blog = (permissions?.title === 'EC' && can_access_EC_space) ||
			!highlighted_section ?
		(
			<div className="dashboard-list u-margin-top-0">

				<div className="c-title c-title--v2 u-margin-top-20">
					<h2 className="c-title__txt">
						Actus Synergies
					</h2>
				</div>

				{
					blog_items.length > 0 ?
					(
						<Slider key={ state.render_id } type="custom"
							elements={ blog_items }
							bemit={ ['highlighted-blog', 'multiple'] }
							hide-progress
						/>
					)
					: undefined
				}

			</div>
		)
		: undefined;

		output =
		(
			<Layout history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					{ presentation_text }

					<div className="o-grid u-flex home-grids">

						{ my_EC_block }

						<div className="o-grid__item-9 u-flex
							u-margin-bottom-15 u-no-padding">

							{ right_elements }

						</div>

						{ can_access_EC_space ? catalog_links : undefined }

					</div>

					{
						member_ad_blog_slider && state.active_private_sales?.[0] ?
						(
							<SliderWithSideElement>

								<PrivateSaleLink title="Vente privée"
									private_sale={ state.active_private_sales?.[0] }
								/>

								{
									member_ad_blog_slider &&
									state.active_private_sales?.[1] ?
									(
										<div
											className="front-slider-side-wrapper__col">
											<PrivateSaleLink title="Vente privée"
												private_sale={ state.active_private_sales?.[1] }
											/>
										</div>
									)
									: undefined
								}

								{ member_ad_blog_slider }

							</SliderWithSideElement>
						)
						: member_ad_blog_slider
					}

					{ synergies_blog }

					{ highlighted_section }

					<div className="dashboard-social-link">

						<div className="dashboard-social-link__txt">
							Suivez nous
						</div>

						<a href="https://www.facebook.com/synergies64/"
							target="_blank" rel="noopener noreferrer"
							className="dashboard-social-link__link">
							<FacebookIcon
								className="dashboard-social-link__icon"
							/>
						</a>

						<a href="https://www.instagram.com/asso_synergies/"
							target="_blank" rel="noopener noreferrer"
							className="dashboard-social-link__link">
							<InstagramIcon
								className="dashboard-social-link__icon"
							/>
						</a>

					</div>

				</div> { /* /page-content */ }

				<GetActivePrivateSales onSuccess={ component.handlePrivateSale } />

			</Layout>
		);

		return output;
	}
}

function Place ({ place, ...props })
{
	let thumbnail;

	if (place.images?.[0]?.url)
	{
		thumbnail = place.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail } />
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	let name = app.getTruncatedText(place.name, 60).toUpperCase();

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['place', 'slider']) }
			key={ place.id }>

			<div className="c-model-preview c-model-preview--home">
				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ '/accueil/lieux/' + place.id }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ '/accueil/lieux/' + place.id }
							className="c-model-preview__title-link">
							{ name }
						</Link>
					</h2>

					<div className="c-model-preview__infos">

						<div className="c-model-preview__buttons">

							<Link href={ '/accueil/lieux/' + place.id }
								className="c-model-preview__link">
								<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
								</svg>Voir le lieu
							</Link>

						</div>

					</div>

				</div>

			</div>

		</div>
	);

	return output;
}

function Product ({ product, ...props })
{
	let thumbnail;

	if (product.images?.[0]?.url)
	{
		thumbnail = product.images[0].url;
	}
	else if (product._artist?.images?.[0]?.url)
	{
		thumbnail = product._artist.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail } />
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	let place_name = product._places[0] ? product._places[0].name : '';

	place_name = place_name.toUpperCase();

	const online_type = getOnlineType(product.online_type);

	let name = app.getTruncatedText(product.name, 60).toUpperCase();

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['product', 'slider']) }
			key={ product.id }>

			<div className="c-model-preview c-model-preview--home">

				{
					online_type ?
					(
						<Link className="c-model-preview__online-type"
							href={ '/accueil/catalogue/' + product.id }>
							{ online_type }
						</Link>
					)
					: undefined
				}

				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ '/accueil/catalogue/' + product.id }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ '/accueil/catalogue/' + product.id }
							className="c-model-preview__title-link">
							{ name }
						</Link>
					</h2>

					<div className="c-model-preview__infos">

						<div className="c-model-preview__buttons">

							<Link href={ '/accueil/catalogue/' + product.id }
								className="c-model-preview__link">
								<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
								</svg>Fiche produit
							</Link>

						</div>

					</div>

				</div>

			</div>

		</div>
	);

	return output;
}

function BlogArticle ({ blog, ...props })
{
	let thumbnail;

	if (blog.images?.[0]?.url)
	{
		thumbnail = blog.images[0].url;
	}
	else if (blog._artist?.images?.[0]?.url)
	{
		thumbnail = blog._artist.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail }
			/>
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	let title = app.getTruncatedText(blog.title, 60).toUpperCase();

	const url = props.type === 'synergies'
	? '/blog-synergies/' + blog.id
	: props.type === 'ad'
	? '/promotions/' + blog.id
	: props.type === 'legal'
	? '/blog-juridique/' + blog.id
	: '/accueil/mon-espace/blog/' + blog.id;

	const modifiers = ['home'].concat(props.bemit || []);

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['blog', 'slider', 'home']) }
			key={ blog.id }>

			<div className={ bemit('c-model-preview', modifiers) }>

				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ url }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ url }
							className="c-model-preview__title-link">
							{ title }
						</Link>
					</h2>

				</div>

			</div>

		</div>
	);

	return output;
}